import { useGetRole } from '@/config/accounts/roles/roles/role/client';
import { useSession } from '@/providers/session-provider';

// Custom functionalities are role-global capabilities stored on
// `Role.customFunctionalities` (e.g. 'gdpr_admin'), separate from the
// model-scoped CRUD permissions exposed by usePerms. The profile/session
// serializes the role as `{ id }` only, so fetch the full role to read them.
export function useCustomFunctionality(key: string): {
  hasAccess: boolean;
  isPending: boolean;
} {
  const { data } = useSession();
  const roleId = data?.user.role?.id;
  const { data: role, isLoading } = useGetRole({
    id: roleId,
    enabled: !!roleId && !!key,
  });
  return {
    hasAccess: !!key && !!role?.customFunctionalities?.includes(key),
    isPending: isLoading,
  };
}

export function useHasCustomFunctionality(key: string): boolean {
  return useCustomFunctionality(key).hasAccess;
}
